import React from "react";
import { useNavigate } from "react-router-dom";
import { Link2, CheckCircle2, Bot, Loader2, Megaphone } from "lucide-react";
import { Button } from "../../ui/button";

export const FunnelConnect = ({ campaign, connectedLink, funnels, selFunnel, setSelFunnel, connecting, connectFunnel }) => {
  const navigate = useNavigate();
  return (
    <div data-testid="funnel-connect" className="rounded-2xl border border-white/10 bg-[#121212] p-5">
      <div className="flex items-center gap-2 mb-1">
        <Link2 size={18} className="text-purple-400" />
        <h3 className="font-display font-bold text-lg">Elige la página para tus prospectos</h3>
      </div>
      <p className="text-sm text-zinc-400 mb-4">¿A dónde llegan los interesados cuando ven tu campaña? Elige una opción y haz clic en <strong className="text-zinc-200">"Utilizar esta"</strong>:</p>
      {(campaign?.landing_slug || campaign?.funnel_slug) && (
        <div className="mb-4 rounded-xl bg-green-500/10 border border-green-500/30 p-3 flex items-center gap-2 text-sm">
          <CheckCircle2 size={16} className="text-green-400 shrink-0" />
          <span className="text-green-300 break-all">
            {campaign?.landing_slug ? "Página de Aterrizaje conectada: " : "Embudo conectado: "}{connectedLink}
          </span>
        </div>
      )}
      <div className="grid sm:grid-cols-2 gap-4">
        <div className="rounded-xl border border-purple-500/30 bg-[#0e0a16] p-4 flex flex-col">
          <div className="flex items-center gap-2 mb-1"><Bot size={18} className="text-purple-400" /><span className="font-semibold">Embudo con cuestionario</span></div>
          <p className="text-xs text-zinc-400 flex-1">La IA crea una página con un <strong>cuestionario inteligente</strong> que califica a tus prospectos y te avisa de los mejores. Ideal para <strong>filtrar y reclutar</strong>.</p>
          <Button data-testid="use-funnel" onClick={() => connectFunnel("ai")} disabled={connecting === "ai"} className="mt-3 bg-purple-600 hover:bg-purple-500 rounded-xl">
            {connecting === "ai" ? <Loader2 className="animate-spin mr-2" size={16} /> : <Bot size={16} className="mr-2" />} Utilizar esta
          </Button>
          {funnels.length > 0 && (
            <div className="mt-3 pt-3 border-t border-white/10">
              <p className="text-[11px] text-zinc-500 mb-1.5">¿Ya tienes un embudo? Conéctalo:</p>
              <select data-testid="funnel-select" value={selFunnel} onChange={(e) => setSelFunnel(e.target.value)}
                className="w-full bg-[#121212] border border-white/15 rounded-xl px-3 py-2 text-xs mb-2 focus:outline-none focus:ring-2 focus:ring-purple-500">
                {funnels.map((f) => <option key={f.funnel_id} value={f.funnel_id}>{f.title}</option>)}
              </select>
              <Button data-testid="connect-existing" onClick={() => connectFunnel("existing")} disabled={connecting === "existing"} variant="outline" size="sm" className="w-full border-yellow-400/40 bg-transparent hover:bg-yellow-400 hover:text-black rounded-xl text-xs">
                {connecting === "existing" ? <Loader2 className="animate-spin mr-2" size={14} /> : <Link2 size={14} className="mr-1.5" />} Conectar el existente
              </Button>
            </div>
          )}
        </div>
        <div className="rounded-xl border border-yellow-400/30 bg-black p-4 flex flex-col">
          <div className="flex items-center gap-2 mb-1"><Megaphone size={18} className="text-yellow-impact" /><span className="font-semibold">Página de Aterrizaje</span></div>
          <p className="text-xs text-zinc-400 flex-1">Una página atractiva con tu mensaje ampliado por IA e imágenes, y botones para que el prospecto te escriba <strong>directo por WhatsApp</strong>. Ideal para <strong>informar y enganchar</strong>.</p>
          <Button data-testid="use-landing" onClick={() => navigate(`/dashboard/landing/${campaign.gc_id}`)} className="mt-3 bg-yellow-400 hover:bg-yellow-300 text-black font-bold rounded-xl">
            <Megaphone size={16} className="mr-2" /> Utilizar esta
          </Button>
        </div>
      </div>
    </div>
  );
};
